import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";

const DragOrUploadFileBox = ({ onFileDrop, children }) => {
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const preventDefault = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    // Suppress drag-and-drop events globally
    window.addEventListener("dragover", preventDefault);
    window.addEventListener("drop", preventDefault);

    // Cleanup listeners on unmount
    return () => {
      window.removeEventListener("dragover", preventDefault);
      window.removeEventListener("drop", preventDefault);
    };
  }, []);

  const handleDragOver = (event) => {
    event.preventDefault(); // Prevent default to allow drop
    event.stopPropagation();
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);

    // Check if files are present in the drop event
    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      onFileDrop(event); // Pass the file to the parent-provided function
      event.dataTransfer.clearData();
    }
  };

  return (
    <Box
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "20px",
        padding: "20px",
        border: "2px dashed #1976d2",
        borderRadius: "10px",
        backgroundColor: isDragging ? "#e1f5fe" : "#f4f6f8",
        transition: "background-color 0.3s ease",
        "&:hover": {
          backgroundColor: "#e1f5fe",
        },
      }}
    >
      {children}
    </Box>
  );
};

export default DragOrUploadFileBox;
